import { FormWithFieldsShape } from './types'
import React from 'react'
import DisplayFields from './DisplayFields'

// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'FC'.
const CorporateForm: FC<FormWithFieldsShape> = ({ fields, mobile }) => {
  const {
    corporateName,
    corporateDocument,
    businessPhone,
    stateRegistration,
    tradeName,
  } = fields

  return (
    <div className="vtex-profile-form__profile-container__wrapper">
      <div>{corporateName}</div>
      <div>{tradeName}</div>
      <DisplayFields
        mobile={mobile}
        firstField={businessPhone}
        secondField={corporateDocument}
      />
      {stateRegistration}
    </div>
  )
}

export default CorporateForm
